export class FileListModel {
    code_name: string
    code_no: number
    code_type: number
    file_name: string
    link_seq: number
    clinic_no: number
    private _header: string

    set header(value: string) {
        this._header = value;
    }
    get header(): string {
        let strTmp = '';
        strTmp += `${this.code_name} -- ${this.file_name}`;
        return strTmp
    }

    constructor(
        code_name: string,
        file_name: string,
        link_seq: number
    ) {
        this.code_name = code_name
        this.file_name = file_name
        this.link_seq = link_seq
    }
}